import React, { useContext, useEffect, useState } from "react"
import MFeedMasonry from "../blocks/m_feed_masonry"
import DfbSpinner from "../ui-kit/dfb_spinner"
import { retrieveItemImageFromHero } from "../utilities"
import { getMostVisitedCombinedCached } from "../../services/content"
import { useSubscriptionPageUrl } from "../../hooks/headerLinks/subscriptionPage"
import useLocalCollectionHandler from "../../hooks/useLocalCollectionHandler"
import { t } from "../../i18n-utility"
import PageContext from "../page-context"

const MFeedMasonryPss = ({
  headline,
  subheadline,
  source,
  space_before_class,
  space_after_class,
}) => {
  const subscriptionUrl = useSubscriptionPageUrl()
  const [dataLoaded, setDataLoaded] = useState(undefined)
  const [isLoggedIn, setIsLoggedIn] = useState(false)

  const {
    collectionForPage,
    hasNextPage,
    setFilteredFullCollection,
    handleNextPage,
  } = useLocalCollectionHandler([], 8, 1)

  const { translations } = useContext(PageContext)

  const init = async () => {
    try {
      const pages = await getMostVisitedCombinedCached()
      const items =
        source === "tag" ? pages.mostVisitedByTag : pages.mostVisitedByCategory
      setIsLoggedIn(!!pages.loggedIn)

      const collection = retrieveItemImageFromHero([...items], "")

      // we will not add the special items if nothing else is found
      // in order to hide the complete element when the list is empty
      if (collection.length > 0) {
        collection.splice(3, 0, {
          uid: -1,
          type: "highlightArticles",
          add_class: "u-Theme-dark",
          title: t(translations, "highlight_articles.headlines.most_read"),
          content: {},
          collection: pages.mostVisited.slice(0, 3),
        })

        const mostRecent =
          pages.mostRecentNewsAndColumn.length >= 3
            ? pages.mostRecentNewsAndColumn.slice(0, 3)
            : []
        let mostRecentPos = 3

        if (!pages.loggedIn) {
          collection.splice(4, 0, {
            uid: -2,
            type: "signupCard",
            content: {},
          })
          mostRecentPos = 6
        }

        if (mostRecent.length) {
          collection.splice(mostRecentPos, 0, {
            uid: -3,
            type: "highlightArticles",
            add_class: "u-Theme-dark--secondary",
            title: t(translations, "highlight_articles.headlines.recent"),
            content: {},
            collection: mostRecent,
          })
        }
      }
      setDataLoaded(true)
      setFilteredFullCollection(collection)
    } catch (err) {
      console.error(
        "Hide MasonryPSS since dynamic content cannot be loaded",
        err
      )
      setDataLoaded(false)
      setFilteredFullCollection([])
    }
  }

  useEffect(() => {
    init()
  }, [])

  useEffect(() => {
    if (
      collectionForPage &&
      collectionForPage.length &&
      window.upgradeAllBehaviours
    ) {
      // ensure grid and images are initialized by ui kit
      window.upgradeAllBehaviours()
    }
  }, [collectionForPage])

  if (dataLoaded === undefined) {
    return (
      <section className="m-Feed m-Feed--mansory">
        <div className="m-Feed-wrapper">
          <div className="m-Feed-container">
            <div className="m-Feed-content">
              <DfbSpinner type="continuous" autoLoop={true} />
            </div>
          </div>
        </div>
      </section>
    )
  }

  if (dataLoaded === false) {
    return null
  }

  return (
    <MFeedMasonry
      data={{
        uid: "pss",
        items_per_page: 8,
        headline: isLoggedIn ? headline : undefined,
        subheadline: isLoggedIn ? subheadline : undefined,
        anchorLink: isLoggedIn ? subscriptionUrl : undefined,
        anchorLabel: isLoggedIn ? "Abonnements bearbeiten" : undefined,
        space_before_class: space_before_class,
        space_after_class: space_after_class,
      }}
      collectionForPage={collectionForPage}
      handleNextPage={handleNextPage}
      hasNextPage={hasNextPage}
    />
  )
}

export default MFeedMasonryPss
